import { useSyncExternalStore } from 'react';
import {
  getLanguage,
  MOBILE_MEDIA_QUERY,
  subscribeToLanguage,
} from './useUserClient.helpers.ts';
import type { TUserClient } from './useUserClient.types.ts';
import { useMediaQuery } from '#hooks/use-media-query/index.ts';

export const useUserClient = (): TUserClient => {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  const locale = useSyncExternalStore(subscribeToLanguage, getLanguage);

  return {
    userClient: isMobile ? 'mobile' : 'web',
    isMobile,
    userAgent: window.navigator.userAgent,
    locale,
  };
};
